enum ScheduleTypes {
  SendNow = "sendNow",
  SendOn = "sendOn",
  SendBy = "sendBy",
}
export default ScheduleTypes;
